<template>
  <div class="box sales-hubspot">
    <details-box-heading :label="hubspot.name" />

    <div v-if="hubspot.project_name" class="box-content mb-2">
      <details-static-data-field field="Project" :value="hubspot.project_name" />
    </div>

    <div class="box-content mb-2">
      <div class="buttons is-left">
        <a class="button is-small hubspot-button" :href="hubspot.deal_url" target="_blank"
          >Open deal in HubSpot</a
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import DetailsPaneBase from './DetailsPaneBase.vue'

/**
 * The HubSpot deal belonging to this address (EH-1840).
 *
 * For some projects werving works in HubSpot and for others only in ERP. The
 * backend only delivers this section when a link exists, so for most addresses
 * this block is simply absent.
 */
@Component({
  name: 'DetailsHubspotBox',
})
export default class DetailsHubspotBox extends DetailsPaneBase {
  get hubspot() {
    return this.components.hubspot || {}
  }
}
</script>

<style scoped lang="scss">
.hubspot-button {
  background-color: #ff7a59;
  color: white;
  border-color: #ff7a59;
}
</style>
